var map = {
	"./CityScan.tsx": 64200,
	"./Confirmation.tsx": 39421,
	"./Dashboard.tsx": 50116,
	"./DashboardCity.tsx": 97602,
	"./Downloads.tsx": 49572,
	"./Faq.tsx": 56661,
	"./FusionData.tsx": 63945,
	"./Header.tsx": 44259,
	"./HeaderWithSearch.tsx": 36563,
	"./HighlightedLinks.tsx": 89629,
	"./IndicatorOverview.tsx": 94827,
	"./InsightsSynthesis.tsx": 66179,
	"./LatestNews.tsx": 78513,
	"./News.tsx": 41196,
	"./Paragraphs.tsx": 82487,
	"./PublicationCalendar.tsx": 27911,
	"./Reports.tsx": 12973,
	"./Search.tsx": 7304,
	"./SearchFunction.tsx": 72690,
	"./SourceRequest.tsx": 53711,
	"./Text.tsx": 25089
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39867;